<!--P109、P111-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'BrandManage'})">品牌管理</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">品牌详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">品牌名称</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">配送价系数</div>
      <input v-model="search.coefficient" @keyup="inputLimitPositiveFloat($event)" @blur="search.coefficient=formatPositiveFloat($event)" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <button @click="btnHistory" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">历史记录
      </button>
    </div>
    <div class="div_operation_table cs_align_center" style="margin-top:400px;">
      <button @click="btnCancel" class="cs_btn cs_btn_sm ui_btn_ghost_blue"
              type="button">取消
      </button>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue ui_margin_left_88"
              type="button">保存
      </button>
    </div>
    <div class="div_bottom"></div>

    <!--历史记录弹窗，默认显示-->
    <div v-if="isDialogHistoryShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:632px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">历史记录</div>
        </div>
        <div class="cs_margin_top_lg div_table cs_padding_horizontal_sm">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="209px">修改时间</th>
              <th width="96px">配送价系数</th>
              <th width="100%">修改人</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in historyList">
              <td width="44px">{{index+1}}</td>
              <td width="209px">{{item.cstCreate}}</td>
              <td width="96px">{{item.modifyRatio}}</td>
              <td width="100%">{{item.operatorName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>historyList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-historyList.length)">
                <td width="40px"></td>
                <td width="209px"></td>
                <td width="96px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn_dialog ui_btn_blue" @click="closeDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "BrandDetail",
    components: {},
    data: function () {
      return {
        search: {
          coefficient: "",
          name: "",
          originCoefficient: "",
        },
        isDialogHistoryShow: false,
        historyList:[],
        PAGE_SIZE: 10,
      }
    },
    created: function () {
    },
    mounted: function() {
      this.search.name = this.$route.query.name;
      this.search.coefficient = this.$route.query.rate;
      this.search.originCoefficient = this.$route.query.rate;
    },
    methods: {
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.name, "品牌名称");
          WhParameter.verifyNotEmpty(this.search.coefficient, "配送价系数");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.search.coefficient!=this.search.originCoefficient){
          this.$alert("配送价系数发生改变，将重新调整采购货品的配送价，确认修改吗？", (clickConfirm) => {
            if (clickConfirm) {
              this.save();
            }
          }, true);
        }else {
          this.save();
        }
      },
      save(){
        this.$ajax.brand.modify.bind(this)(this.$route.query.id,this.search.name,this.search.coefficient,(data) => {
          this.$toast("保存成功");
          this.$router.replace({name:'BrandManage'});
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$router.go(-1);
      },
      btnHistory(){
        this.$ajax.brand.listLog.bind(this)(this.$route.query.id,(data) => {
          this.historyList = data.data;
          this.isDialogHistoryShow = true;
        }, (data) => {
        }, true);
      },
      closeDialog(){
        this.isDialogHistoryShow = false;
      },
    },
  }
</script>

<style scoped>
  .cs_table tbody{max-height: 411px;}
  .width_412{width: 412px;}
</style>



// WEBPACK FOOTER //
// src/page/brand/BrandDetail.vue